import { ChakraProvider, SystemContext } from "@chakra-ui/react"
import { ColorModeProvider } from "./color-mode"

export function Provider({
  value,
  children
}: {
  value: SystemContext
  children: React.ReactNode
}) {
  return (
    <ChakraProvider value={value}>
      <ColorModeProvider
        // We don't officially support dark mode.
        enableSystem={false}
      >
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  )
}
